import { createIconSet } from '@expo/vector-icons';
import glyphMap from '~/../assets/fonts/Feather/unicodesMap.json';
export default createIconSet(glyphMap, 'Feather', require('~/../assets/fonts/Feather/Feather.ttf'));
